<template>
  <div class="layout">
    <WaterMark />
    <suspense>
      <main>
        <slot />
      </main>
    </suspense>
    <GnbNavigationBar v-if="!isDontNeedNavPage" />
  </div>
</template>
<script setup lang="ts">
const route = useRoute()

const isDontNeedNavPage = computed(() => route.path.includes('/insurance/purchase/callback/fail'))
</script>
